<template>
  <div id="TextParsing">
    <div class="topic_title">{{bankdata.order}}.( {{typetext}} ){{bankdata.question_title}}</div>
    <div class="topic_box">
      <el-input
        :rows="5"
        disabled
        placeholder="请输入内容"
        type="textarea"
        v-model="bankdata.user_select"
      ></el-input>
    </div>
    <div class="el-Parsing">
      <div class="title">
        <div class="title_item">
          <span class="cank">参考答案：</span>
          <span class="blue">{{bankdata.question_answer}}</span>
        </div>
        <div class="title_item">
          <span class="cank">你的答案：</span>
          <span class="red">{{bankdata.user_select}}</span>
        </div>
      </div>
      <div class="content" v-if="bankdata.question_describe">答案解析：{{bankdata.question_describe}}</div>
      <div class="content" v-else>答案解析：解析正在更新中...</div>
    </div>
  </div>
</template>
<script>
module.exports = {
  name: 'text-parsing',
  props: ['bankdata', 'typetext'],
  data () {
    return {
      content: '',
      listData: '',
      img_url: ''
    }
  },
  mounted () {
    if (this.bankdata) {
      this.initFn()
    }
  },
  watch: {
    bankdata () {
      this.content = ""
      this.initFn()
    }
  },
  computed: {
  },
  methods: {
    initFn: function () {
      let arr = this.bankdata.question_select
      if (this.bankdata.img) {
        this.img_url = sessionStorage.getItem("base_url") + this.bankdata.img
      } else {
        this.img_url = ""
      }
      if (!(arr instanceof Array)) {
        arr = arr.split('###')
        let obj = []
        for (let i = 0; i < arr.length; i++) {
          obj[i] = {}
          obj[i].lable = arr[i]
          obj[i].value = arr[i].substring(0, 1)
        }
        this.bankdata.question_select = obj
      }
      this.listData = this.bankdata
    }
  }
}
</script>
